import { memo } from 'react'

import { Head } from './Head'

/**
 * @description
 * S2O案件で行うアフィリエイトスクリプトのタグ
 * ストア詳細ページと、ストア完了画面それぞれのスクリプトを設置する
 * https://app.clickup.com/t/908127/UT-15040
 */
export const ResultPlusScript = memo(
  ({ title, isCompleted }: { title: string; isCompleted: boolean }) => {
    return (
      <Head title={title}>
        {isCompleted ? (
          <script
            id="resultPlusComplete"
            dangerouslySetInnerHTML={{
              __html: `
      (function() {
        var uqid = "cf26S373Sef9aai9";
        var gid  = 1009;
        var uid = "";
        var uid2 = "";
        var af = "";
        var pid = "";
        var amount = "";
        var a = document.createElement("script");
        a.src = "//ad.resultplus2.jp/ac/action_js.php";
        a.id = "afadaction-" + Date.now();
        a.addEventListener("load", function () { (new fpcAction(a.id)).groupAction(gid, af, [uid, uid2], pid, amount, uqid) });
        document.head.appendChild(a)
      })();
      `,
            }}
          />
        ) : (
          <script
            id="resultPlusCommon"
            dangerouslySetInnerHTML={{
              __html: `
      (function() {
        var uqid = "cf26S373Sef9aai9";
        var gid  = 1009;
        var a=document.createElement("script");
        a.dataset.uqid=uqid;a.dataset.gid=gid;a.id="afadfpc-cf26S373Sef9aai9gid548-"+Date.now();
        a.src="//ad.resultplus2.jp/fpc/cookie_js.php?scriptId="+encodeURIComponent(a.id);
        document.head.appendChild(a);
        })();`,
            }}
          />
        )}
      </Head>
    )
  }
)
